import { Component, OnInit } from "@angular/core";
import { HeaderComponent } from "../header/header.component";

@Component({
  selector: "app-main-navigation",
  templateUrl: "./navigation.component.html",
})
export class NavigationComponent extends HeaderComponent implements OnInit {
  ngOnInit() {
    super.ngOnInit();
  }

  login() {
    this.router.navigate(["/auth"]);
  }
}
